export default __webpack_public_path__ + "static/media/whatsapp.fcb5f4c7.svg";